import moment from "moment";

const millisecondsPerDay = 24 * 60 * 60 * 1000;

export const isValidCostDate = value => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value))
    return false;
  const timestamp = Date.parse(`${value}T00:00:00Z`);
  return (
    Number.isFinite(timestamp) &&
    new Date(timestamp).toISOString().slice(0, 10) === value
  );
};

export const normalizeCostDate = value => {
  if (isValidCostDate(value)) return value;
  if (
    typeof value !== "string" ||
    value[10] !== "T" ||
    !isValidCostDate(value.slice(0, 10))
  )
    return "";
  // Match the UTC calendar date displayed by the job's existing date input.
  const date = moment.utc(value, moment.ISO_8601, true);
  return date.isValid() ? date.format("YYYY-MM-DD") : "";
};

export const getCostDateWarning = (date, today) => {
  if (!isValidCostDate(date) || !isValidCostDate(today)) return "";
  // Compare calendar dates at UTC midnight so daylight saving does not shift the threshold.
  const daysFromToday =
    (Date.parse(`${date}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) /
    millisecondsPerDay;

  if (daysFromToday < -30)
    return "This cost date is more than 30 days ago. Confirm the work date and check with finance if the accounting period is closed.";
  return "";
};
